/**
 * This build's own commit SHA, the PR it shipped, and build time -- baked
 * in by vite.config.ts's `define`, not read at runtime. "dev" when neither
 * Cloudflare Pages nor a local git checkout could say (see vite.config.ts's
 * buildSha()).
 *
 * One shared module rather than reading the __BUILD_*__ globals directly
 * wherever they're shown, so there is exactly one place that decides what
 * "dev" means and what the badge links to.
 */
export const BUILD_SHA = __BUILD_SHA__;
export const BUILD_PR = __BUILD_PR__;
export const BUILD_TIME = __BUILD_TIME__;

export const isDevBuild = BUILD_SHA === "dev";

/** "PR #135" when the build's commit says which PR it was (this repo
 * squash-merges, so its subject line always does) -- the actual number to
 * look for, not a SHA that needs a click through to GitHub before it says
 * anything. Falls back to the short SHA on a commit made with no PR (a
 * direct push), never inventing a number that isn't really there. */
export function buildLabel(): string {
  if (isDevBuild) return "dev";
  return BUILD_PR != null ? `PR #${BUILD_PR}` : BUILD_SHA.slice(0, 7);
}

/** Where the badge links to -- the PR itself when known, otherwise the
 * bare commit. */
export function buildUrl(): string | null {
  if (isDevBuild) return null;
  return BUILD_PR != null
    ? `https://github.com/dalecooper-code/viewpointav/pull/${BUILD_PR}`
    : `https://github.com/dalecooper-code/viewpointav/commit/${BUILD_SHA}`;
}
